export enum UrlType {
    Node = 0,
    Media = 1,
    External = 2,
}